import { motion } from "framer-motion";

const LOGO =
  "https://customer-assets.emergentagent.com/job_d8bde34f-08da-465f-b45b-a2f93a9d58b4/artifacts/hw02tjz7_IntegrityGO%20logo%201.jpg";

export const Header = ({ onCtaClick }) => {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/80 border-b-2 border-ink"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-[68px] md:h-[80px] flex items-center justify-between">
        <img
          src={LOGO}
          alt="Integrity Go"
          className="h-9 md:h-11 w-auto object-contain"
          data-testid="header-logo"
        />
        <button
          onClick={onCtaClick}
          data-testid="header-cta-button"
          className="hidden sm:inline-flex font-mono text-xs md:text-sm font-bold uppercase tracking-[0.18em] bg-acid text-ink border-2 border-ink px-5 md:px-6 py-2.5 md:py-3 transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-cyan"
        >
          Get The Dope Conversation Starter
        </button>
      </div>
    </motion.header>
  );
};
